import { useEffect } from "react";
import Lenis from "lenis";
import SignalField from "@/components/SignalField";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Problem from "@/components/Problem";
import Workflow from "@/components/Workflow";
import Perform from "@/components/Perform";
import Progress from "@/components/Progress";
import Outcomes from "@/components/Outcomes";
import Focus from "@/components/Focus";
import Closing from "@/components/Closing";
import Footer from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
    let raf = 0;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onClick = (e) => {
      const link = e.target.closest?.('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute("href").slice(1);
      const el = id === "top" ? document.body : document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: id === "top" ? 0 : -80 });
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div data-testid="landing-page">
      <SignalField />
      <Nav />
      <main id="top">
        <Hero />
        <Problem />
        <Workflow />
        <Perform />
        <Progress />
        <Outcomes />
        <Focus />
        <Closing />
      </main>
      <Footer />
    </div>
  );
}
